var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBrainIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80.674,
    height: 86.562,
    viewBox: "0 0 80.674 86.562",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_312",
    "data-name": "Group 312",
    transform: "translate(-235.011 -659.641)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_406",
    "data-name": "Path 406",
    d: "M367.57,661.342l.106.028Z",
    transform: "translate(-99.58 -1.278)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_407",
    "data-name": "Path 407",
    d: "M249.891,784.866q-.018.79.023,1.532Q249.874,785.657,249.891,784.866Z",
    transform: "translate(-11.174 -94.07)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_408",
    "data-name": "Path 408",
    d: "M294.928,734.995l-.015-.026Z",
    transform: "translate(-44.999 -56.587)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_409",
    "data-name": "Path 409",
    d: "M365.692,660.914l.08.018Z",
    transform: "translate(-98.169 -0.956)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_410",
    "data-name": "Path 410",
    d: "M361.915,660.243l.055.009Z",
    transform: "translate(-95.332 -0.452)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_411",
    "data-name": "Path 411",
    d: "M380.278,665.967q.232.113.459.231Q380.511,666.08,380.278,665.967Z",
    transform: "translate(-109.126 -4.752)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_412",
    "data-name": "Path 412",
    d: "M360.021,660l.017,0Z",
    transform: "translate(-93.909 -0.271)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_413",
    "data-name": "Path 413",
    d: "M369.446,661.833l.087.026Z",
    transform: "translate(-100.989 -1.647)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_414",
    "data-name": "Path 414",
    d: "M373.171,663c.059.021.119.044.178.065C373.29,663.044,373.23,663.021,373.171,663Z",
    transform: "translate(-103.787 -2.523)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_415",
    "data-name": "Path 415",
    d: "M376.872,664.417h0c.223.093.441.192.657.293C377.311,664.609,377.094,664.51,376.872,664.417Z",
    transform: "translate(-106.565 -3.587)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_416",
    "data-name": "Path 416",
    d: "M375.025,663.677c.06.023.12.048.18.072C375.145,663.725,375.085,663.7,375.025,663.677Z",
    transform: "translate(-105.18 -3.032)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_417",
    "data-name": "Path 417",
    d: "M363.286,983.985c-.008-.023-.016-.045-.024-.068C363.269,983.94,363.278,983.963,363.286,983.985Z",
    transform: "translate(-96.344 -243.601)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_418",
    "data-name": "Path 418",
    d: "M371.314,662.386l.112.037Z",
    transform: "translate(-102.392 -2.062)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_419",
    "data-name": "Path 419",
    d: "M363.8,660.547l.074.014Z",
    transform: "translate(-96.752 -0.68)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_420",
    "data-name": "Path 420",
    d: "M317.975,670.1l.106-.062Z",
    transform: "translate(-62.324 -7.806)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_421",
    "data-name": "Path 421",
    d: "M335.14,662.455l.029-.008Z",
    transform: "translate(-75.218 -2.108)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_422",
    "data-name": "Path 422",
    d: "M337.06,661.916h0Z",
    transform: "translate(-76.66 -1.708)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_423",
    "data-name": "Path 423",
    d: "M396.967,677q.173.147.336.292C397.194,677.193,397.082,677.1,396.967,677Z",
    transform: "translate(-121.663 -13.039)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_424",
    "data-name": "Path 424",
    d: "M329.393,664.5l.025-.01Z",
    transform: "translate(-70.901 -3.643)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_425",
    "data-name": "Path 425",
    d: "M333.224,663.1h0Z",
    transform: "translate(-73.779 -2.597)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_426",
    "data-name": "Path 426",
    d: "M321.766,668.071l.032-.017Z",
    transform: "translate(-65.171 -6.32)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_427",
    "data-name": "Path 427",
    d: "M400.532,680.2q.155.147.3.29Q400.687,680.35,400.532,680.2Z",
    transform: "translate(-124.341 -15.446)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_428",
    "data-name": "Path 428",
    d: "M327.48,665.218l.094-.04Z",
    transform: "translate(-69.464 -4.159)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_429",
    "data-name": "Path 429",
    d: "M348.571,659.841l.039,0Z",
    transform: "translate(-85.308 -0.149)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_430",
    "data-name": "Path 430",
    d: "M354.31,659.646h0Z",
    transform: "translate(-89.619 -0.004)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_431",
    "data-name": "Path 431",
    d: "M358.121,659.821h0Z",
    transform: "translate(-92.482 -0.135)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_432",
    "data-name": "Path 432",
    d: "M350.487,659.72h0Z",
    transform: "translate(-86.747 -0.059)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_433",
    "data-name": "Path 433",
    d: "M398.681,678.492q.2.184.4.363Q398.886,678.676,398.681,678.492Z",
    transform: "translate(-122.951 -14.161)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_434",
    "data-name": "Path 434",
    d: "M356.216,659.7l.042,0Z",
    transform: "translate(-91.051 -0.046)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_435",
    "data-name": "Path 435",
    d: "M397.744,1007.436c-.116-.005-.232-.012-.346-.02C397.512,1007.424,397.628,1007.43,397.744,1007.436Z",
    transform: "translate(-121.987 -261.253)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_436",
    "data-name": "Path 436",
    d: "M395.168,1007.224q-.173-.015-.342-.033Q395,1007.209,395.168,1007.224Z",
    transform: "translate(-120.055 -261.083)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_437",
    "data-name": "Path 437",
    d: "M400.417,1007.547c-.114,0-.227,0-.34-.006C400.189,1007.544,400.3,1007.546,400.417,1007.547Z",
    transform: "translate(-124 -261.346)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_438",
    "data-name": "Path 438",
    d: "M375.958,1000.811c-.064-.041-.129-.081-.192-.123C375.828,1000.73,375.894,1000.77,375.958,1000.811Z",
    transform: "translate(-105.737 -256.198)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_439",
    "data-name": "Path 439",
    d: "M374.262,999.6c-.058-.043-.118-.084-.174-.128C374.145,999.511,374.2,999.552,374.262,999.6Z",
    transform: "translate(-104.476 -255.281)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_440",
    "data-name": "Path 440",
    d: "M392.685,1006.912q-.168-.021-.333-.047C392.462,1006.882,392.573,1006.9,392.685,1006.912Z",
    transform: "translate(-118.196 -260.839)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_441",
    "data-name": "Path 441",
    d: "M385.762,1005.378c-.1-.027-.19-.054-.283-.083C385.572,1005.324,385.667,1005.351,385.762,1005.378Z",
    transform: "translate(-113.033 -259.659)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_442",
    "data-name": "Path 442",
    d: "M381.578,1003.854c-.082-.033-.164-.066-.244-.1C381.414,1003.788,381.5,1003.821,381.578,1003.854Z",
    transform: "translate(-109.92 -258.501)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_443",
    "data-name": "Path 443",
    d: "M379.616,1002.941c-.076-.036-.152-.071-.226-.109C379.464,1002.87,379.54,1002.905,379.616,1002.941Z",
    transform: "translate(-108.459 -257.809)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_444",
    "data-name": "Path 444",
    d: "M390.291,1006.5c-.107-.019-.214-.038-.319-.06C390.077,1006.462,390.184,1006.481,390.291,1006.5Z",
    transform: "translate(-116.409 -260.519)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_445",
    "data-name": "Path 445",
    d: "M383.627,1004.666c-.089-.03-.177-.06-.264-.092C383.45,1004.606,383.538,1004.636,383.627,1004.666Z",
    transform: "translate(-111.444 -259.118)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_446",
    "data-name": "Path 446",
    d: "M387.984,1005.989c-.1-.023-.2-.046-.3-.071C387.782,1005.943,387.883,1005.966,387.984,1005.989Z",
    transform: "translate(-114.689 -260.127)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_447",
    "data-name": "Path 447",
    d: "M388.221,670.461q.209.136.411.274Q388.43,670.6,388.221,670.461Z",
    transform: "translate(-115.093 -8.128)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_448",
    "data-name": "Path 448",
    d: "M394.994,675.366q.184.148.36.3Q395.178,675.514,394.994,675.366Z",
    transform: "translate(-120.181 -11.813)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_449",
    "data-name": "Path 449",
    d: "M439.782,705.573a11.449,11.449,0,0,0-4.48-4.023,8.789,8.789,0,0,0,2.325-1.676c2.2-2.214,3.186-5.537,2.94-9.879-.2-3.579-1.495-6.311-3.841-8.12a13.264,13.264,0,0,0-8.04-2.375,11.571,11.571,0,0,0,2.321-7.413c-.27-3.57-2.582-6.768-6.873-9.505-5-3.192-10.234-3.8-15.125-1.75a20.1,20.1,0,0,0-6.233,4.264,1.2,1.2,0,0,0-.841,0,20.887,20.887,0,0,1,1.412,1.54,1.289,1.289,0,0,1,.294.82v9c0-.01,0-.02,0-.03v-8.5c2.365-2.723,9.5-9.3,19.1-3.175,3.563,2.273,5.477,4.8,5.688,7.513.33,4.25-3.606,7.777-3.643,7.81a1.289,1.289,0,0,0,1.1,2.234c.057-.012,5.746-1.11,9.265,1.612,1.722,1.331,2.675,3.423,2.833,6.217.2,3.564-.529,6.22-2.173,7.894a6.948,6.948,0,0,1-4.277,1.939,6.293,6.293,0,0,0-3.888-3.453,1.289,1.289,0,1,0-.553,2.518c.035.008,3.483.841,2.564,7.154a1.289,1.289,0,1,0,2.551.371,14.886,14.886,0,0,0,.128-3.512,10.227,10.227,0,0,1,5.241,3.872,7.393,7.393,0,0,1,.491,6.1c-2.518,8.613-10.112,7.3-10.43,7.236a1.29,1.29,0,0,0-1.163,2.172c.216.219,5.2,5.451-.721,12.331a7.923,7.923,0,0,1-5.61,3.062c-4.069.214-7.672-3.125-7.707-3.157a1.289,1.289,0,0,0-2.157,1.15c.005.033.507,3.389-1.421,5.621a7.176,7.176,0,0,1-5.224,2.157V719.546c0-.01,0-.02,0-.03v25.394a1.289,1.289,0,0,1-1.261,1.289h-.025c.132,0,.262,0,.392,0,3.592,0,6.307-1.034,8.072-3.077a9.031,9.031,0,0,0,2.041-4.933,12.98,12.98,0,0,0,7.41,2.209,10.39,10.39,0,0,0,7.447-3.955c4.966-5.766,3.658-10.8,2.18-13.563,3.257-.24,8.515-1.818,10.655-9.135A9.851,9.851,0,0,0,439.782,705.573Z",
    transform: "translate(-125.396 -0.001)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_450",
    "data-name": "Path 450",
    d: "M365.766,989.625q-.185-.293-.341-.592Q365.58,989.331,365.766,989.625Z",
    transform: "translate(-97.969 -247.443)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_451",
    "data-name": "Path 451",
    d: "M367.066,991.83c-.064-.091-.126-.183-.185-.275C366.94,991.646,367,991.738,367.066,991.83Z",
    transform: "translate(-99.062 -249.337)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_452",
    "data-name": "Path 452",
    d: "M382.892,667.3q.265.143.52.291Q383.157,667.442,382.892,667.3Z",
    transform: "translate(-111.09 -5.753)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_453",
    "data-name": "Path 453",
    d: "M385.3,668.651c.2.115.388.233.576.353C385.693,668.884,385.5,668.766,385.3,668.651Z",
    transform: "translate(-112.903 -6.768)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_454",
    "data-name": "Path 454",
    d: "M367.714,992.793q.216.306.47.6l.033.036-.034-.037Q367.93,993.1,367.714,992.793Z",
    transform: "translate(-99.688 -250.268)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_455",
    "data-name": "Path 455",
    d: "M371.131,996.846c-.042-.041-.086-.079-.127-.121C371.045,996.767,371.089,996.805,371.131,996.846Z",
    transform: "translate(-102.16 -253.221)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_456",
    "data-name": "Path 456",
    d: "M377.742,1001.927c-.069-.039-.14-.076-.208-.117C377.6,1001.85,377.673,1001.888,377.742,1001.927Z",
    transform: "translate(-107.065 -257.041)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_457",
    "data-name": "Path 457",
    d: "M361.4,975.378a10.557,10.557,0,0,0,.35,1.761,10.579,10.579,0,0,1-.35-1.761Z",
    transform: "translate(-94.945 -237.185)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_458",
    "data-name": "Path 458",
    d: "M392.6,673.508q.252.188.489.377Q392.853,673.7,392.6,673.508Z",
    transform: "translate(-118.383 -10.417)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_459",
    "data-name": "Path 459",
    d: "M390.525,672.011q.215.151.422.3Q390.74,672.162,390.525,672.011Z",
    transform: "translate(-116.824 -9.292)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_460",
    "data-name": "Path 460",
    d: "M283.978,917.561h21.011a1.289,1.289,0,0,0,0-2.578H284.676a11.966,11.966,0,0,1,.535-1.142,11.966,11.966,0,0,0-.535,1.142h-.73a1.289,1.289,0,0,0,0,2.578h.032a10.479,10.479,0,0,0,.409,4.7A10.479,10.479,0,0,1,283.978,917.561Z",
    transform: "translate(-35.792 -190.958)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_461",
    "data-name": "Path 461",
    d: "M372.655,998.275c-.052-.044-.1-.086-.155-.13C372.551,998.19,372.6,998.232,372.655,998.275Z",
    transform: "translate(-103.283 -254.288)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_462",
    "data-name": "Path 462",
    d: "M472.156,863.522a1.29,1.29,0,0,0-.6,1.722c.02.041,1.957,4.12.528,7.414-.757,1.744-2.376,3.013-4.811,3.771a1.289,1.289,0,1,0,.766,2.462c3.192-.993,5.351-2.75,6.418-5.223,1.894-4.392-.481-9.345-.583-9.554A1.288,1.288,0,0,0,472.156,863.522Z",
    transform: "translate(-173.799 -153.06)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_463",
    "data-name": "Path 463",
    d: "M421.895,842.043c6.637.433,6.727,5.684,6.715,6.288a1.289,1.289,0,0,0,1.248,1.323h.041a1.289,1.289,0,0,0,1.288-1.249c.089-2.879-1.7-8.451-9.124-8.935a1.289,1.289,0,1,0-.168,2.573Z",
    transform: "translate(-139.484 -135.088)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_464",
    "data-name": "Path 464",
    d: "M447.268,724.459c3.988,1.131,6.495,2.987,7.45,5.517,1.6,4.24-1.545,9.207-1.581,9.263a1.289,1.289,0,0,0,2.164,1.4c.16-.246,3.889-6.091,1.835-11.56-1.256-3.344-4.34-5.733-9.164-7.1a1.289,1.289,0,1,0-.7,2.48Z",
    transform: "translate(-158.746 -46.792)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_465",
    "data-name": "Path 465",
    d: "M252.741,783.641a15.44,15.44,0,0,1-.244-4.023c.017-.3.045-.584.079-.865h-2.6c-.024.236-.044.475-.058.719q-.023.407-.031.8-.018.79.023,1.532a16.29,16.29,0,0,0,.2,1.835Z",
    transform: "translate(-11.174 -89.478)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_466",
    "data-name": "Path 466",
    d: "M291.249,744.91V667.453a1.289,1.289,0,0,0-.294-.819,20.89,20.89,0,0,0-1.412-1.54l-.049-.048q-.145-.143-.3-.29l-.065-.063c-.127-.119-.259-.24-.4-.363l-.09-.079q-.163-.145-.336-.292l-.131-.111q-.175-.147-.36-.3l-.106-.086q-.238-.188-.489-.377l-.094-.069q-.207-.152-.422-.3l-.162-.112q-.2-.138-.411-.274l-.15-.1q-.282-.179-.576-.353l-.08-.045q-.255-.148-.52-.291l-.192-.1q-.226-.118-.459-.231c-.064-.031-.127-.062-.192-.093-.215-.1-.433-.2-.657-.293h0c-.092-.038-.184-.074-.276-.111l-.18-.072c-.094-.036-.189-.069-.283-.1-.059-.021-.119-.044-.178-.065-.117-.041-.234-.078-.351-.116l-.111-.037c-.126-.039-.252-.076-.378-.112l-.087-.026c-.12-.034-.24-.064-.36-.094l-.106-.028c-.129-.032-.258-.06-.387-.088l-.08-.018c-.132-.028-.263-.053-.4-.077l-.074-.014c-.138-.024-.277-.046-.415-.067l-.055-.009q-.226-.033-.454-.058l-.017,0q-.23-.026-.46-.044h-.013c-.144-.011-.288-.02-.432-.027l-.042,0q-.231-.01-.462-.014h-.012q-.474-.006-.949.018h0c-.146.007-.292.018-.438.03l-.039,0a15.679,15.679,0,0,0-2.859.514h0c-.15.041-.3.085-.449.131l-.029.008q-.236.073-.473.154h0q-.465.158-.928.346l-.025.01c-.127.052-.254.106-.382.161l-.094.039q-.7.305-1.389.676l-.032.017q-.419.225-.837.476l-.106.062q-.235.142-.47.292c-4.291,2.737-6.6,5.935-6.873,9.505a10.943,10.943,0,0,0,1.605,6.3l.015.026c.017.029.035.057.052.087.212.358.431.695.649,1.005a16.911,16.911,0,0,0-3.491.355,1.282,1.282,0,0,1-1.1,1.954h-3.361c-.03.022-.06.042-.09.065a9.436,9.436,0,0,0-3.272,4.823h2.744a6.736,6.736,0,0,1,2.093-2.774c3.519-2.722,9.208-1.624,9.263-1.612a1.289,1.289,0,0,0,1.294-.5h-3.251a1.289,1.289,0,0,1,0-2.578h2.243c-1.146-1.3-3.059-3.948-2.824-6.964.211-2.712,2.125-5.24,5.688-7.513,9.593-6.12,16.733.449,19.1,3.172V743.6a7.185,7.185,0,0,1-5.21-2.145c-1.953-2.244-1.437-5.6-1.433-5.634a1.289,1.289,0,0,0-2.158-1.15c-.035.034-3.6,3.368-7.692,3.158a7.918,7.918,0,0,1-5.624-3.063c-2.743-3.185-3.146-6.017-2.768-8.161h-2.6a10.478,10.478,0,0,0,.409,4.7,14.8,14.8,0,0,0,3,5.144,10.391,10.391,0,0,0,7.447,3.955,13,13,0,0,0,7.41-2.209h0a10.573,10.573,0,0,0,.35,1.761c.035.121.072.242.113.364.007.022.016.045.024.067a8.748,8.748,0,0,0,.514,1.205q.155.3.341.592l.022.036c.059.092.121.184.185.275.008.011.015.022.022.033q.216.306.47.6l.034.037c.1.117.206.231.315.341.041.042.085.08.127.121.081.079.161.158.246.233.051.045.1.087.155.13.079.067.158.135.24.2.057.044.116.085.174.128.08.059.16.119.243.176.062.042.128.082.192.123.082.053.164.106.248.156.068.041.139.078.208.117s.167.093.253.138.15.073.226.109.17.082.257.12.163.068.244.1.172.07.261.1.175.062.264.092.173.059.262.087.188.056.283.083.176.049.265.072.2.049.3.072.178.04.269.058.212.041.319.06c.091.016.181.031.273.046.11.017.221.032.333.047.094.012.188.024.283.034q.169.018.342.033.148.013.3.023c.114.008.23.014.346.02s.213.009.321.011.225.005.34.006l.151,0c.125,0,.252,0,.379,0h.038A1.289,1.289,0,0,0,291.249,744.91Z",
    transform: "translate(-13.003)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_467",
    "data-name": "Path 467",
    d: "M257.907,813.649h5.653c.037,0,.072.008.108.011a1.285,1.285,0,0,0-1.3-1.64,7.082,7.082,0,0,1-4.814-1.942,6.456,6.456,0,0,1-1-1.316h-2.862a9.369,9.369,0,0,0,2.03,3.132,8.792,8.792,0,0,0,2.325,1.677h0C258,813.594,257.954,813.623,257.907,813.649Z",
    transform: "translate(-14.033 -112.021)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_468",
    "data-name": "Path 468",
    d: "M271.581,903.672c.029-.053.059-.106.088-.158.078-.136.156-.263.232-.38s.15-.226.22-.326l.069-.1c.068-.093.132-.176.19-.249.175-.219.3-.349.329-.379a1.29,1.29,0,0,0-1.154-2.178,8.432,8.432,0,0,1-1.723.1c-.215-.007-.444-.022-.686-.047a9.73,9.73,0,0,1-1.156-.189,8.753,8.753,0,0,1-2.506-.987h-4.006a11.324,11.324,0,0,0,7.822,3.746,11.942,11.942,0,0,0-.535,1.142Z",
    transform: "translate(-19.883 -179.648)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_469",
    "data-name": "Path 469",
    d: "M250.89,843.657a6.187,6.187,0,0,1,.806-2.17,8.38,8.38,0,0,1,2.833-2.717h-4.011c-.019.022-.04.041-.059.063a9.434,9.434,0,0,0-.958,1.3,8.782,8.782,0,0,0-1.222,3.522Z",
    transform: "translate(-9.966 -134.563)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_470",
    "data-name": "Path 470",
    d: "M252.885,873.665a12.168,12.168,0,0,1-1.634-3.535,10.983,10.983,0,0,1-.307-1.352h-2.6a13.4,13.4,0,0,0,.437,2.076,16.176,16.176,0,0,0,1.1,2.812Z",
    transform: "translate(-10.013 -157.105)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_471",
    "data-name": "Path 471",
    d: "M314.978,740.96a1.289,1.289,0,0,0,0-2.578H297.243a1.289,1.289,0,0,0,0,2.578h17.735Z",
    transform: "translate(-45.781 -59.151)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_472",
    "data-name": "Path 472",
    d: "M241.4,746.2h7.763a1.289,1.289,0,0,0,0-2.578h-9.847a9.436,9.436,0,0,1,3.272-4.822c.03-.023.06-.043.09-.065h3.361a1.282,1.282,0,0,0,1.1-1.954,16.925,16.925,0,0,1,3.49-.356c-.218-.311-.437-.648-.649-1.005.212.358.431.695.649,1.005a16.937,16.937,0,0,0-3.49.356,1.284,1.284,0,0,0-1.1-.624H236.3a1.289,1.289,0,0,0,0,2.578h6.379c-.03.022-.06.042-.09.065a9.436,9.436,0,0,0-3.272,4.822H236.3a1.289,1.289,0,0,0,0,2.578h2.506c-.024.236-.044.475-.058.719.014-.244.034-.483.058-.719Z",
    transform: "translate(0 -56.926)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_473",
    "data-name": "Path 473",
    d: "M312.643,769.679a1.289,1.289,0,0,0,1.289,1.289h13.583a1.289,1.289,0,0,0,0-2.578H313.932A1.289,1.289,0,0,0,312.643,769.679Z",
    transform: "translate(-58.318 -81.693)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_474",
    "data-name": "Path 474",
    d: "M242.52,795.437h.579a1.289,1.289,0,0,0,0-2.578h-4.155a16.284,16.284,0,0,1-.2-1.835,16.284,16.284,0,0,0,.2,1.835H236.3a1.289,1.289,0,0,0,0,2.578h3.359a9.364,9.364,0,0,0,2.03,3.132,9.367,9.367,0,0,1-2.03-3.132Z",
    transform: "translate(0 -98.696)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_475",
    "data-name": "Path 475",
    d: "M278.964,799.688a1.289,1.289,0,0,0,1.289,1.289h21.962a1.289,1.289,0,0,0,0-2.578H280.253A1.289,1.289,0,0,0,278.964,799.688Z",
    transform: "translate(-33.018 -104.236)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_476",
    "data-name": "Path 476",
    d: "M244.562,830.746h4.963a1.286,1.286,0,0,0,.108-2.567c-.036,0-.071-.011-.108-.011h-5.652c.047-.025.094-.054.141-.079h0c-.047.025-.094.053-.141.079H236.3a1.289,1.289,0,0,0,0,2.578h4.251c-.019.022-.04.041-.059.063.019-.022.04-.041.059-.063Z",
    transform: "translate(0 -126.54)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_477",
    "data-name": "Path 477",
    d: "M319.972,828.406H303.891a1.289,1.289,0,0,0,0,2.578h16.081a1.289,1.289,0,0,0,0-2.578Z",
    transform: "translate(-50.775 -126.778)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_478",
    "data-name": "Path 478",
    d: "M240.931,860.993h1.158a1.289,1.289,0,1,0,0-2.578H236.3a1.289,1.289,0,1,0,0,2.578h4.631Z",
    transform: "translate(0 -149.321)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_479",
    "data-name": "Path 479",
    d: "M298.607,860.993a1.289,1.289,0,0,0,0-2.578H275.451a1.289,1.289,0,1,0,0,2.578Z",
    transform: "translate(-29.411 -149.321)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_480",
    "data-name": "Path 480",
    d: "M245.6,891h3.158a1.289,1.289,0,0,0,0-2.578H236.3a1.289,1.289,0,0,0,0,2.578h9.3Z",
    transform: "translate(0 -171.864)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_481",
    "data-name": "Path 481",
    d: "M319.972,888.423H303.891a1.289,1.289,0,0,0,0,2.578h16.081a1.289,1.289,0,0,0,0-2.578Z",
    transform: "translate(-50.775 -171.864)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_482",
    "data-name": "Path 482",
    d: "M243.1,918.43h-6.8a1.289,1.289,0,0,0,0,2.578h6.8a1.289,1.289,0,0,0,0-2.578Z",
    transform: "translate(0 -194.405)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrainIcon);
export default __webpack_public_path__ + "static/media/brain-icon.14f13824ea7d4a998e37cea0a7fac52e.svg";
export { ForwardRef as ReactComponent };